import script from "./StatisticsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsView.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsView.vue?vue&type=style&index=0&id=3b49db76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b49db76"]])

export default __exports__